import React from 'react';
import { Box, Typography } from '@mui/material';
import { NotificationBadge } from './NotificationBadge';

interface NotificationRowProps {
  onClick: () => void;
  label: string;
  count: string | number;
}
export const NotificationRow: React.FC<NotificationRowProps> = ({ onClick, label, count }) => {
  if (count === 0) {
    return null;
  }
  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        mb: 0.5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Typography fontWeight="bold" variant="body2">
        {label}
      </Typography>
      <Box sx={{ ml: 'auto' }}>
        <NotificationBadge value={count} />
      </Box>
    </Box>
  );
};
